import React from 'react';
import { useSelector } from 'react-redux';
import { selectActionTypePieChartData } from '../../../../../../slices/teamStatsSlice';
import DistributionPieCard from './DistributionPieCard';

const ActionType = () => {
  const pieChartData = useSelector(selectActionTypePieChartData)
  
  return (
    <DistributionPieCard title="Total Investigations" pieChartData={pieChartData} />
  )
}

export default ActionType;
